export const environment = {
  production: false,
  name: 'dev',
  sentryUrl: '',
  apiUrl: 'https://internal.backend.dev.thelearning-lab.com/',
  apiCoreAppUrl: 'https://internal.core.dev.thelearning-lab.com/app/',
  zoomHostUrl: 'https://zoom-client.dev.thelearning-lab.com/',
  renderingToolUrl: 'https://app.dev.thelearning-lab.com/api/renderer',
  hostLookupUrl: 'https://controltower.dev.thelearning-lab.com/api/instances/resolver',
  liveUpdateHostUrl: 'https://app-bcdn.dev.thelearning-lab.com',
  hash: new Date().toISOString().replace(/\.|:|-/g, ''),
  adminBaseDomain: 'https://internal.admin.lms-development.thelearning-lab.com',
  frontBaseDomain: 'https://internal.app.lms-development.thelearning-lab.com',
  version: '',
  chatGraphqlUrl: 'https://657qra4crrcvpo6f3bnlozsbl4.appsync-api.eu-west-1.amazonaws.com/graphql',
  chatGraphqlWsUrl: 'wss://657qra4crrcvpo6f3bnlozsbl4.appsync-realtime-api.eu-west-1.amazonaws.com/graphql',
};
